import PropTypes from "prop-types";
import React from "react";
import classnames from "classnames";
import styles from "./related-designer-image.css";

function RelatedDesignerImage({ designer }) {
    return (
        <div className={styles.relatedDesignerCard}>
            {designer.image_url && (
                <a href={designer.designer_url}>
                    <img
                        src={designer.image_url}
                        alt={designer.designer_name}
                        className={classnames(styles.relatedDesignerImage)}
                    />
                </a>
            )}
            <a href={designer.designer_url} className={styles.relatedDesignerName}>
                {designer.designer_name}
            </a>
        </div>
    );
}

RelatedDesignerImage.propTypes = {
    designer: PropTypes.object.isRequired,
};

export default RelatedDesignerImage;
